// actions/payroll.checks.js
import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";

const handleError = (dispatch, err, message) => {
    if (err?.response?.status === 401) {
        dispatch({ type: LOGOUT });
        return;
    }

    return err?.response?.data || {
        success: false,
        error: {
            message,
        },
    };
};

/**
 * GET one (uuid) OR nothing (you likely only use the uuid form)
 * GET /payroll/checks/i/:uuid
 */
export const get = ({ uuid } = {}) => async (dispatch) => {
    try {
        if (!isGuid(uuid)) return { success: false, item: null };
        const res = await api.get(`/payroll/checks/i/${uuid}`);
        return res.data;
    } catch (err) {
        return handleError(dispatch, err, "The payroll check could not be loaded.");
    }
};

/**
 * SEARCH (THUNK VERSION)
 * GET /payroll/checks/p/:page/s/:size/o/:order/:direction/:search?
 */
export const search = ({
    search = "",
    page = 0,
    size = 25,
    order = "payDate",
    direction = "DESC",
} = {}) => async (dispatch) => {
    try {
        const term = (search == null || String(search).trim() === "") ? "*" : String(search).trim();
        const enc = encodeURIComponent(term);
        const url = `/payroll/checks/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}/${enc}`;
        const res = await api.get(url);
        return res.data;
    } catch (err) {
        return handleError(dispatch, err, "Payroll checks could not be loaded.");
    }
};

/**
 * SAVE
 * POST /payroll/checks
 */
export const save = (payload = {}) => async (dispatch) => {
    try {
        const res = await api.post(`/payroll/checks`, payload);
        return res.data;
    } catch (err) {
        return handleError(dispatch, err, "The payroll check could not be saved.");
    }
};

/**
 * DESTROY
 * DELETE /payroll/checks/i/:uuid
 */
export const destroy = (uuid) => async (dispatch) => {
    try {
        if (!isGuid(uuid)) return { success: false };
        const res = await api.delete(`/payroll/checks/i/${uuid}`);
        return res.data;
    } catch (err) {
        return handleError(dispatch, err, "The payroll check could not be removed.");
    }
};

export const pay = (staff, payperiod) => async (dispatch) => {
    try {
        if (!isGuid(staff) || !isGuid(payperiod)) return { success: false };
        const res = await api.get(`/payroll/checks/issue/${staff}/${payperiod}`);
        return res.data;
    } catch (err) {
        return handleError(dispatch, err, "The payroll check could not be issued.");
    }
}

export const unpay = (check) => async (dispatch) => {
    try {
        if (!isGuid(check)) return { success: false };
        const res = await api.delete(`/payroll/checks/issue/${check}`);
        return res.data;
    } catch (err) {
        return handleError(dispatch, err, "The payroll check could not be deleted.");
    }
}
